import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface OverlayModalProps {
  open: boolean;
  onClose: () => void;
  label?: string;
  children: ReactNode;
}

export default function OverlayModal({ open, onClose, label, children }: OverlayModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-8 animate-modal-fade bg-foreground-950/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-2xl max-h-[88vh] overflow-y-auto rounded-lg border border-background-200 bg-background-50 animate-modal-pop"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={label}
      >
        <button
          type="button"
          aria-label="关闭"
          onClick={onClose}
          className="absolute top-4 right-4 z-10 w-9 h-9 flex items-center justify-center rounded-md bg-background-50/90 backdrop-blur text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
        {children}
      </div>
    </div>,
    document.body,
  );
}